import React, { useState, useEffect } from "react";
import SideBar from "../../components/sidebar/SideBar";
import TabComponent from "../../components/tabs/TabComponent";
import GeneralSettings from "../../components/GeneralSettings/GeneralSettings";
import {
  getAllPaymentInfo,
  getUserProfile,
  getUserDetails,
  getUserOrgDetails,
} from "../../services/userService";
import { toast } from "react-toastify";

import "./Settings.scss";
import UserManagement from "./UserManagement";
import OrganizationInfo from "./OrganizationInfo";

function Settings() {
  const [userInfo, setUserInfo] = useState({});
  const [userListDetails, setUserListDetails] = useState({});
  const [organisationDetails, setOrganisationDetails] = useState({});

  const fetchUserDetails = async () => {
    try {
      let response = await getUserProfile();

      setUserInfo(response);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchUserData = async () => {
    try {
      const response = await getUserProfile();
      setUserListDetails(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  const fetchOrgDetails = async () => {
    try {
      const response = await getUserOrgDetails();
      setOrganisationDetails(response?.data);
    } catch (error) {
      console.error("Error fetching organization details:", error);
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchUserData();
    fetchUserDetails();
    fetchOrgDetails();
  }, []);

  const tabs = [
    {
      label: "Profile Info",
      content: <GeneralSettings userInfo={userInfo} />,
    },
    {
      label: "User Management",
      content: <UserManagement userListDetails={userListDetails} />,
    },
    {
      label: "Organization Info",
      content: <OrganizationInfo organisationDetails={organisationDetails} />,
    },
  ];
  return (
    <>
      <div className="col-12">
        <div className="workspace-container">
          <h2 className="page-title mt-4 ml-3">Settings</h2>
          <TabComponent
            isBenchmarkDataSaved={true}
            tabs={tabs}
            className="Settings-tab"
          />
        </div>
      </div>
    </>
  );
}

export default Settings;
